<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card"> 
      <vs-list>
        <vs-list-header title="원어민 발음이 끝나면 따라 읽으세요." icon-pack="feather" icon="icon-info">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-header>
        <vs-list-item class="msg-grp-container">
            <vs-input-number label="반복횟수" min="1" max="6" v-model="repeatCount" />
        </vs-list-item>
      </vs-list>

      <perfect-scrollbar>
        <vs-list class="inner-scroll-height">
          <vs-list-item v-for="(content, index) in contentList" :class="contentIndex===index ? 'msg-grp-container text-primary' : 'msg-grp-container'" 
            :key="index" 
            :title="content.sentence" 
            :subtitle="content.translation">
              <vs-chip style="width:100px" v-if="(contentIndex === index) && userTurn" color="warning mr-0">따라 읽으세요</vs-chip>
          </vs-list-item>
        </vs-list>
      </perfect-scrollbar>

      <div class="text-center">
        <audio ref="audioPlayer" 
            controls
            v-on:ended="audioFinish"
            v-on:loadeddata="audioLoaded"
            preload="auto"
            hidden
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar,
    PerfectScrollbar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      duration: 0,
      userTurn: false,
      repeatCount: 1,
      playCount: 0
    }
  },
  computed: {
    content () {
      return this.contentList[this.contentIndex]
    },
    audioPlayer () {
      return this.$refs.audioPlayer
    }
  },
  methods: {
    onReload () {
      this.contentIndex = 0
      this.userTurn = false
      this.duration = 0
      this.playCount = 0
      this.startAlert()
    },
    onStart () {
      if (this.studyFinished) return
      this.audioPlayer.src = this.content.audio
      this.audioPlayer.play()
    },
    audioLoaded () {
      this.duration = (this.audioPlayer.duration * 1000) + 1000
    },
    audioFinish () {

      this.playCount++
      if (this.playCount < this.repeatCount) {
        this.onStart()
        return
      }

      this.playCount = 0
      this.userTurn = true
      setTimeout(function () {
        this.userTurn = false
        if (this.contentIndex >= this.contentsLen - 1) {
          this.onComplete()
        } else {
          this.contentIndex++
          this.onStart()
        }
      }.bind(this), this.duration)
    },
    startAlert () {
      this.startStudyDlg('원어밀 발음으로 따라 읽습니다.')
    },
    acceptAlert () {
      this.onStart()
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
      } 
      this.contentList.push(content)
    }
    this.contentsLen = this.contentList.length
    this.startAlert()

  },
  mounted () {
  }
  
}

</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
